/* Hero image magnifier
   - Desktop (hover-capable): magnifier button + sharp inner-zoom lens on hover,
     and a click lightbox (tap-to-zoom-point, drag to pan).
   - Touch devices: direct pinch-to-zoom on the hero image (two fingers zoom & pan
     the image you're currently viewing; release snaps back). No button/click.
   The current image is detected by slide position, so it always matches what the
   shopper is looking at — including after swiping on mobile. */
(function () {
  var HIRES = 1600; // width requested from the Shopify CDN for sharp zoom
  var LB_SCALE = 2.4; // lightbox zoom factor on tap (desktop)

  var MAG_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';
  var CLOSE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var canHover = window.matchMedia('(hover: hover) and (min-width: 750px)').matches;
  var isTouch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;

  function hires(src) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + HIRES);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + HIRES;
  }

  /* ---------- Current slide (by position, not .is-active) ---------- */
  function getCurrentSlide(gallery) {
    var list = gallery.querySelector('[id^="Slider-Gallery"], .product__media-list');
    if (!list) return null;
    var items = [].slice.call(list.querySelectorAll('.product__media-item'));
    if (!items.length) return null;
    var listRect = list.getBoundingClientRect();
    var centerX = listRect.left + listRect.width / 2;
    var best = null, bestDist = Infinity;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      if (r.width < 1) return; // hidden (e.g. inactive desktop slides)
      var c = r.left + r.width / 2;
      var d = Math.abs(c - centerX);
      if (d < bestDist) { bestDist = d; best = it; }
    });
    if (!best) best = list.querySelector('.product__media-item.is-active') || items[0];
    var container = best.querySelector('.product-media-container');
    var media = best.querySelector('.product__media');
    var img = media && media.querySelector('img');
    var isImage = container && /media-type-image/.test(container.className);
    return { item: best, container: container, media: media, img: img, isImage: isImage };
  }

  /* ================= Desktop lightbox ================= */
  var lb, lbImg, lbState = { s: 1, x: 0, y: 0, fitW: 0, fitH: 0 };

  function buildLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'hero-zoom-lb';
    lb.innerHTML =
      '<button type="button" class="hero-zoom-lb__close" aria-label="Close">' + CLOSE_SVG + '</button>' +
      '<img class="hero-zoom-lb__img" alt="">' +
      '<div class="hero-zoom-lb__hint">Click image to zoom · drag to move</div>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.hero-zoom-lb__img');

    lb.querySelector('.hero-zoom-lb__close').addEventListener('click', closeLightbox);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLightbox();
    });
    bindLightboxGestures();
  }

  function applyTransform() {
    lbImg.style.transform = 'translate(' + lbState.x + 'px,' + lbState.y + 'px) scale(' + lbState.s + ')';
  }
  function clampPan() {
    var maxX = Math.max(0, (lbState.fitW * lbState.s - lbState.fitW) / 2);
    var maxY = Math.max(0, (lbState.fitH * lbState.s - lbState.fitH) / 2);
    lbState.x = Math.max(-maxX, Math.min(maxX, lbState.x));
    lbState.y = Math.max(-maxY, Math.min(maxY, lbState.y));
  }
  function resetZoom() {
    lbState.s = 1; lbState.x = 0; lbState.y = 0;
    lb.classList.remove('is-zoomed');
    applyTransform();
  }
  function zoomToPoint(clientX, clientY) {
    var r = lbImg.getBoundingClientRect();
    var dx = clientX - (r.left + r.width / 2);
    var dy = clientY - (r.top + r.height / 2);
    lbState.s = LB_SCALE;
    lbState.x = dx * (1 - LB_SCALE);
    lbState.y = dy * (1 - LB_SCALE);
    clampPan();
    lb.classList.add('is-zoomed');
    applyTransform();
  }
  function bindLightboxGestures() {
    var dragging = false, moved = false, startX = 0, startY = 0, baseX = 0, baseY = 0;
    function down(px, py) { dragging = true; moved = false; startX = px; startY = py; baseX = lbState.x; baseY = lbState.y; }
    function move(px, py) {
      if (!dragging || lbState.s === 1) return;
      var ddx = px - startX, ddy = py - startY;
      if (Math.abs(ddx) + Math.abs(ddy) > 4) { moved = true; lb.classList.add('is-panning'); }
      lbState.x = baseX + ddx; lbState.y = baseY + ddy; clampPan(); applyTransform();
    }
    function up(px, py) {
      if (!dragging) return;
      dragging = false; lb.classList.remove('is-panning');
      if (!moved) { if (lbState.s === 1) zoomToPoint(px, py); else resetZoom(); }
    }
    lbImg.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', function (e) { up(e.clientX, e.clientY); });
  }
  function openLightbox(src) {
    buildLightbox();
    resetZoom();
    lbImg.src = src;
    var measure = function () { var r = lbImg.getBoundingClientRect(); lbState.fitW = r.width; lbState.fitH = r.height; };
    if (lbImg.complete && lbImg.naturalWidth) measure(); else lbImg.onload = measure;
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ================= Touch pinch-to-zoom ================= */
  function dist(t0, t1) { var dx = t0.clientX - t1.clientX, dy = t0.clientY - t1.clientY; return Math.hypot(dx, dy); }
  function mid(t0, t1) { return { x: (t0.clientX + t1.clientX) / 2, y: (t0.clientY + t1.clientY) / 2 }; }

  function setupPinch(viewer, gallery) {
    var overlay = null, backdrop = null, active = false;
    var startDist = 0, startMid = { x: 0, y: 0 }, curScale = 1;

    function cleanup() {
      if (overlay) overlay.remove();
      if (backdrop) backdrop.remove();
      overlay = backdrop = null; active = false; curScale = 1;
    }

    viewer.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2 || active) return;
      var slide = getCurrentSlide(gallery);
      if (!slide || !slide.isImage || !slide.img) return;
      var rect = slide.img.getBoundingClientRect();
      if (rect.width < 1) return;

      active = true;
      startDist = dist(e.touches[0], e.touches[1]);
      startMid = mid(e.touches[0], e.touches[1]);

      backdrop = document.createElement('div');
      backdrop.className = 'hero-pinch-backdrop';
      document.body.appendChild(backdrop);

      overlay = document.createElement('img');
      overlay.className = 'hero-pinch-img';
      overlay.style.left = rect.left + 'px';
      overlay.style.top = rect.top + 'px';
      overlay.style.width = rect.width + 'px';
      overlay.style.height = rect.height + 'px';
      overlay.style.transformOrigin = (startMid.x - rect.left) + 'px ' + (startMid.y - rect.top) + 'px';
      var cur = slide.img.currentSrc || slide.img.src;
      overlay.src = cur; // instant (already cached)
      var hi = new Image();
      hi.onload = function () { if (overlay) overlay.src = hi.src; };
      hi.src = hires(cur);
      document.body.appendChild(overlay);
      e.preventDefault();
    }, { passive: false });

    viewer.addEventListener('touchmove', function (e) {
      if (!active || e.touches.length < 2) return;
      e.preventDefault();
      var d = dist(e.touches[0], e.touches[1]);
      var m = mid(e.touches[0], e.touches[1]);
      curScale = Math.max(1, d / startDist);
      var tx = m.x - startMid.x, ty = m.y - startMid.y;
      overlay.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + curScale + ')';
      backdrop.style.opacity = Math.min((curScale - 1) * 0.6, 0.85);
    }, { passive: false });

    function end() {
      if (!active || !overlay) return;
      overlay.classList.add('is-resetting');
      backdrop.classList.add('is-resetting');
      overlay.style.transform = 'translate(0,0) scale(1)';
      backdrop.style.opacity = '0';
      var o = overlay, b = backdrop;
      overlay = backdrop = null; active = false; curScale = 1;
      setTimeout(function () { if (o) o.remove(); if (b) b.remove(); }, 240);
    }
    viewer.addEventListener('touchend', function (e) { if (active && e.touches.length < 2) end(); });
    viewer.addEventListener('touchcancel', function () { cleanup(); });
  }

  /* ================= Per-gallery init ================= */
  function initGallery(viewer) {
    if (viewer.dataset.heroZoomInit) return;
    var gallery = viewer.closest('media-gallery');
    if (!gallery) return;
    viewer.dataset.heroZoomInit = '1';

    // Touch: pinch-to-zoom directly on the hero
    if (isTouch) setupPinch(viewer, gallery);

    // Desktop (hover): magnifier button + lightbox + hover lens
    if (!canHover) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hero-zoom-btn';
    btn.setAttribute('aria-label', 'Zoom image');
    btn.innerHTML = MAG_SVG;
    viewer.appendChild(btn);

    // Hover-zoom is a toggle: off by default, turned on by clicking the icon.
    var zoomEnabled = false;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      zoomEnabled = !zoomEnabled;
      btn.classList.toggle('hero-zoom-btn--active', zoomEnabled);
      btn.setAttribute('aria-pressed', zoomEnabled ? 'true' : 'false');
      if (!zoomEnabled) resetHover();
    });

    function syncBtn() {
      var s = getCurrentSlide(gallery);
      btn.hidden = !(s && s.isImage && s.img);
    }
    syncBtn();
    var list = gallery.querySelector('[id^="Slider-Gallery"], .product__media-list');
    if (list) new MutationObserver(syncBtn).observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });

    function ensureLayer(s) {
      if (!s.media) return null;
      var layer = s.media.querySelector('.hero-zoom-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'hero-zoom-layer';
        s.media.appendChild(layer);
      }
      layer.style.backgroundImage = 'url("' + hires(s.img.currentSrc || s.img.src) + '")';
      return layer;
    }
    function resetHover() {
      var host = gallery.querySelector('.hero-zoom-host--active');
      if (host) host.classList.remove('hero-zoom-host--active');
    }
    viewer.addEventListener('mousemove', function (e) {
      if (!zoomEnabled) return;
      var s = getCurrentSlide(gallery);
      if (!s || !s.isImage || !s.img) { resetHover(); return; }
      var r = s.img.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { resetHover(); return; }
      var layer = ensureLayer(s);
      if (!layer) return;
      s.media.classList.add('hero-zoom-host--active');
      var px = ((e.clientX - r.left) / r.width) * 100;
      var py = ((e.clientY - r.top) / r.height) * 100;
      layer.style.backgroundPosition = px + '% ' + py + '%';
    });
    viewer.addEventListener('mouseleave', resetHover);
  }

  function initAll() {
    document
      .querySelectorAll('media-gallery slider-component.slider-mobile-gutter:not(.thumbnail-slider)')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  var reinit;
  var host = document.querySelector('product-info') || document.body;
  new MutationObserver(function (mutations) {
    var galleryAdded = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 &&
          (node.matches('media-gallery') || node.querySelector('media-gallery'));
      });
    });
    if (!galleryAdded) return;
    clearTimeout(reinit);
    reinit = setTimeout(initAll, 150);
  })
    .observe(host, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', initAll);
})();
